import { useEffect } from 'react';

import { memberId } from '@trello/session-cookie';
import { TrelloStorage } from '@trello/storage';

import { useMemberLocalePrefQuery } from './MemberLocalePrefQuery.generated';

export function useMemberLocaleCache() {
  const { data } = useMemberLocalePrefQuery({
    variables: { memberId: memberId ?? 'me' },
    skip: !memberId,
    waitOn: ['MemberHeader'],
  });

  useEffect(() => {
    const locale = data?.member?.prefs?.locale;

    if (!locale) {
      return;
    }

    TrelloStorage.set(`locale-${memberId}`, locale);
  }, [data?.member?.prefs?.locale]);
}
